import api from "../config/api";

export const generateOtp = async (email) => {
  return (await api.post("/customer/resetPassword/?flag=generate", { email, flag: "generate" })).data;
};

export const verifyOtp = async (email, otp) => {
  return (await api.post("/customer/resetPassword/?flag=verify", { email, otp, flag: "verify" })).data;
};

export const resetPassword = async (email, password) => {
  return (await api.post("/customer/resetPassword/?flag=updatePassword", { email, password, flag: "updatePassword" })).data;
};
